/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropCampaignWindowBody } from './DropCampaignWindowBody';
import {
    DropCampaignWindowBodyFromJSON,
    DropCampaignWindowBodyFromJSONTyped,
    DropCampaignWindowBodyToJSON,
    DropCampaignWindowBodyToJSONTyped,
} from './DropCampaignWindowBody';
import type { DropStorefrontInput } from './DropStorefrontInput';
import {
    DropStorefrontInputFromJSON,
    DropStorefrontInputFromJSONTyped,
    DropStorefrontInputToJSON,
    DropStorefrontInputToJSONTyped,
} from './DropStorefrontInput';
import type { SurfaceSocialConnection } from './SurfaceSocialConnection';
import {
    SurfaceSocialConnectionFromJSON,
    SurfaceSocialConnectionFromJSONTyped,
    SurfaceSocialConnectionToJSON,
    SurfaceSocialConnectionToJSONTyped,
} from './SurfaceSocialConnection';
import type { PageHeroSection } from './PageHeroSection';
import {
    PageHeroSectionFromJSON,
    PageHeroSectionFromJSONTyped,
    PageHeroSectionToJSON,
    PageHeroSectionToJSONTyped,
} from './PageHeroSection';
import type { DropModeBody } from './DropModeBody';
import {
    DropModeBodyFromJSON,
    DropModeBodyFromJSONTyped,
    DropModeBodyToJSON,
    DropModeBodyToJSONTyped,
} from './DropModeBody';
import type { ChallengeTypography } from './ChallengeTypography';
import {
    ChallengeTypographyFromJSON,
    ChallengeTypographyFromJSONTyped,
    ChallengeTypographyToJSON,
    ChallengeTypographyToJSONTyped,
} from './ChallengeTypography';
import type { SurfaceAllowedGame } from './SurfaceAllowedGame';
import {
    SurfaceAllowedGameFromJSON,
    SurfaceAllowedGameFromJSONTyped,
    SurfaceAllowedGameToJSON,
    SurfaceAllowedGameToJSONTyped,
} from './SurfaceAllowedGame';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { CreateDropStreamingSettings } from './CreateDropStreamingSettings';
import {
    CreateDropStreamingSettingsFromJSON,
    CreateDropStreamingSettingsFromJSONTyped,
    CreateDropStreamingSettingsToJSON,
    CreateDropStreamingSettingsToJSONTyped,
} from './CreateDropStreamingSettings';
import type { LedgerOwner } from './LedgerOwner';
import {
    LedgerOwnerFromJSON,
    LedgerOwnerFromJSONTyped,
    LedgerOwnerToJSON,
    LedgerOwnerToJSONTyped,
} from './LedgerOwner';
import type { SurfaceContentBlock } from './SurfaceContentBlock';
import {
    SurfaceContentBlockFromJSON,
    SurfaceContentBlockFromJSONTyped,
    SurfaceContentBlockToJSON,
    SurfaceContentBlockToJSONTyped,
} from './SurfaceContentBlock';
import type { SurfaceThemeConfig } from './SurfaceThemeConfig';
import {
    SurfaceThemeConfigFromJSON,
    SurfaceThemeConfigFromJSONTyped,
    SurfaceThemeConfigToJSON,
    SurfaceThemeConfigToJSONTyped,
} from './SurfaceThemeConfig';
import type { SurfaceStatus } from './SurfaceStatus';
import {
    SurfaceStatusFromJSON,
    SurfaceStatusFromJSONTyped,
    SurfaceStatusToJSON,
    SurfaceStatusToJSONTyped,
} from './SurfaceStatus';
import type { SurfaceVisibility } from './SurfaceVisibility';
import {
    SurfaceVisibilityFromJSON,
    SurfaceVisibilityFromJSONTyped,
    SurfaceVisibilityToJSON,
    SurfaceVisibilityToJSONTyped,
} from './SurfaceVisibility';
import type { PageNavbarConfig } from './PageNavbarConfig';
import {
    PageNavbarConfigFromJSON,
    PageNavbarConfigFromJSONTyped,
    PageNavbarConfigToJSON,
    PageNavbarConfigToJSONTyped,
} from './PageNavbarConfig';
import type { Distribution } from './Distribution';
import {
    DistributionFromJSON,
    DistributionFromJSONTyped,
    DistributionToJSON,
    DistributionToJSONTyped,
} from './Distribution';
import type { DropReleaseBody } from './DropReleaseBody';
import {
    DropReleaseBodyFromJSON,
    DropReleaseBodyFromJSONTyped,
    DropReleaseBodyToJSON,
    DropReleaseBodyToJSONTyped,
} from './DropReleaseBody';
import type { DropType } from './DropType';
import {
    DropTypeFromJSON,
    DropTypeFromJSONTyped,
    DropTypeToJSON,
    DropTypeToJSONTyped,
} from './DropType';
import type { SurfacePointSystemConfigInput } from './SurfacePointSystemConfigInput';
import {
    SurfacePointSystemConfigInputFromJSON,
    SurfacePointSystemConfigInputFromJSONTyped,
    SurfacePointSystemConfigInputToJSON,
    SurfacePointSystemConfigInputToJSONTyped,
} from './SurfacePointSystemConfigInput';
import type { DropSection } from './DropSection';
import {
    DropSectionFromJSON,
    DropSectionFromJSONTyped,
    DropSectionToJSON,
    DropSectionToJSONTyped,
} from './DropSection';
import type { PageSeo } from './PageSeo';
import {
    PageSeoFromJSON,
    PageSeoFromJSONTyped,
    PageSeoToJSON,
    PageSeoToJSONTyped,
} from './PageSeo';
import type { RosterFieldSpec } from './RosterFieldSpec';
import {
    RosterFieldSpecFromJSON,
    RosterFieldSpecFromJSONTyped,
    RosterFieldSpecToJSON,
    RosterFieldSpecToJSONTyped,
} from './RosterFieldSpec';
import type { DropVideoBody } from './DropVideoBody';
import {
    DropVideoBodyFromJSON,
    DropVideoBodyFromJSONTyped,
    DropVideoBodyToJSON,
    DropVideoBodyToJSONTyped,
} from './DropVideoBody';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface CreateDropsBody
 */
export interface CreateDropsBody {
    /**
     * URL-friendly slug (lowercase, alphanumeric + hyphens)
     * @type {string}
     * @memberof CreateDropsBody
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    description?: string;
    /**
     * 
     * @type {DropType}
     * @memberof CreateDropsBody
     */
    dropType?: DropType;
    /**
     * 
     * @type {SurfaceStatus}
     * @memberof CreateDropsBody
     */
    status?: SurfaceStatus;
    /**
     * 
     * @type {SurfaceVisibility}
     * @memberof CreateDropsBody
     */
    visibility?: SurfaceVisibility;
    /**
     * How this Drop is served, and in what style, per channel. Omit for none — an empty list means undecided, not "listed nowhere".
     * @type {Array<Distribution>}
     * @memberof CreateDropsBody
     */
    distributions?: Array<Distribution>;
    /**
     * 
     * @type {SurfacePointSystemConfigInput}
     * @memberof CreateDropsBody
     */
    pointSystemConfig?: SurfacePointSystemConfigInput;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropsBody
     */
    verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    ownerType?: CreateDropsBodyOwnerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDropsBody
     */
    games?: Array<string>;
    /**
     * 
     * @type {ChallengeThemeColors}
     * @memberof CreateDropsBody
     */
    themeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {ChallengeTypography}
     * @memberof CreateDropsBody
     */
    typography?: ChallengeTypography;
    /**
     * 
     * @type {SurfaceThemeConfig}
     * @memberof CreateDropsBody
     */
    themeConfig?: SurfaceThemeConfig;
    /**
     * 
     * @type {PageHeroSection}
     * @memberof CreateDropsBody
     */
    heroSection?: PageHeroSection;
    /**
     * 
     * @type {PageNavbarConfig}
     * @memberof CreateDropsBody
     */
    navbarConfig?: PageNavbarConfig;
    /**
     * 
     * @type {PageSeo}
     * @memberof CreateDropsBody
     */
    seo?: PageSeo;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    competitionId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDropsBody
     */
    questConfigs?: Array<string>;
    /**
     * 
     * @type {LedgerOwner}
     * @memberof CreateDropsBody
     */
    ledgerOwner?: LedgerOwner;
    /**
     * The Ledger RECORD this Drop's point-granting engagements credit.
     * @type {string}
     * @memberof CreateDropsBody
     */
    ledgerId?: string;
    /**
     * The OnboardingExperience this Drop runs at its door (T7).
     * @type {string}
     * @memberof CreateDropsBody
     */
    onboardingExperienceId?: string;
    /**
     * 
     * @type {Array<SurfaceAllowedGame>}
     * @memberof CreateDropsBody
     */
    allowedGames?: Array<SurfaceAllowedGame>;
    /**
     * 
     * @type {Array<DropSection>}
     * @memberof CreateDropsBody
     */
    sections?: Array<DropSection>;
    /**
     * 
     * @type {CreateDropStreamingSettings}
     * @memberof CreateDropsBody
     */
    streamingSettings?: CreateDropStreamingSettings;
    /**
     * 
     * @type {DropReleaseBody}
     * @memberof CreateDropsBody
     */
    release?: DropReleaseBody;
    /**
     * 
     * @type {Array<DropCampaignWindowBody>}
     * @memberof CreateDropsBody
     */
    campaignWindows?: Array<DropCampaignWindowBody>;
    /**
     * POV this Drop was created as (CREATOR, PUBLISHER, FRANCHISE, GAME, BRAND, COMMUNITY, ESPORTS_PROFESSIONAL, ESPORTS_COLLEGIATE, AGENCY).
     * @type {string}
     * @memberof CreateDropsBody
     */
    pov?: string;
    /**
     * The Drop this one hangs off. Siblings are every other Drop with the same parent — no per-title list to maintain.
     * @type {string}
     * @memberof CreateDropsBody
     */
    parentDropId?: string;
    /**
     * Roster card fields this surface adds over its team's schema, merged by key.
     * @type {Array<RosterFieldSpec>}
     * @memberof CreateDropsBody
     */
    rosterFields?: Array<RosterFieldSpec>;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    streamingTeamId?: string;
    /**
     * 
     * @type {Array<SurfaceSocialConnection>}
     * @memberof CreateDropsBody
     */
    socials?: Array<SurfaceSocialConnection>;
    /**
     * 
     * @type {Array<SurfaceContentBlock>}
     * @memberof CreateDropsBody
     */
    contentBlocks?: Array<SurfaceContentBlock>;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    creatorProfileImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    creatorHeaderImageUrl?: string;
    /**
     * Wide wordmark lockup rendered as the hero logo. Distinct from the square icon in creatorProfileImageUrl.
     * @type {string}
     * @memberof CreateDropsBody
     */
    logoImageUrl?: string;
    /**
     * Uploaded icon asset id. Resolves ahead of creatorProfileImageUrl on read.
     * @type {string}
     * @memberof CreateDropsBody
     */
    iconImageId?: string;
    /**
     * Uploaded wordmark asset id. Resolves ahead of logoImageUrl on read.
     * @type {string}
     * @memberof CreateDropsBody
     */
    logoImageId?: string;
    /**
     * One line under the name. True whether or not anything is launching.
     * @type {string}
     * @memberof CreateDropsBody
     */
    tagline?: string;
    /**
     * Authored name of the enclosing program, shown as the bar's wordmark. Display copy only.
     * @type {string}
     * @memberof CreateDropsBody
     */
    programName?: string;
    /**
     * What this surface calls its members, as a stat label. Authored copy; consumers default to "Members".
     * @type {string}
     * @memberof CreateDropsBody
     */
    memberStatLabel?: string;
    /**
     * The qualifier under the member count — "Worldwide", "Joined". Consumers default to "Joined".
     * @type {string}
     * @memberof CreateDropsBody
     */
    memberStatDetail?: string;
    /**
     * What this Drop is about, in its own words.
     * @type {string}
     * @memberof CreateDropsBody
     */
    synopsis?: string;
    /**
     * Where a visitor buys or plays. The CTA wording changes with release status; this destination does not.
     * @type {string}
     * @memberof CreateDropsBody
     */
    purchaseUrl?: string;
    /**
     * The feature video.
     * @type {string}
     * @memberof CreateDropsBody
     */
    trailerUrl?: string;
    /**
     * Assigned hero-strip videos. Empty falls back to the connected YouTube channel.
     * @type {Array<DropVideoBody>}
     * @memberof CreateDropsBody
     */
    videos?: Array<DropVideoBody>;
    /**
     * The slim rail under the hero — modes pre-launch, the season cadence after. True of a franchise with no launch at all.
     * @type {Array<DropModeBody>}
     * @memberof CreateDropsBody
     */
    modes?: Array<DropModeBody>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDropsBody
     */
    platforms?: Array<string>;
    /**
     * OWGame id once the subject exists in the catalogue. Unlocks telemetry-based matching.
     * @type {string}
     * @memberof CreateDropsBody
     */
    gameRef?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDropsBody
     */
    twitchGameIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDropsBody
     */
    kickCategoryIds?: Array<string>;
    /**
     * Lowercased title/tag aliases — often the only signal before a category exists.
     * @type {Array<string>}
     * @memberof CreateDropsBody
     */
    streamTitleAliases?: Array<string>;
    /**
     * The subject's own Steam store app — drives the purchase link, and the news feed when steamNewsAppId is unset.
     * @type {number}
     * @memberof CreateDropsBody
     */
    steamAppId?: number;
    /**
     * The Steam app whose announcements this subject posts to, when that differs from its store app. Normal for a franchise title. Falls back to steamAppId.
     * @type {number}
     * @memberof CreateDropsBody
     */
    steamNewsAppId?: number;
    /**
     * Short credits line under the name — "Activision · Infinity Ward". Authored, unlike description.
     * @type {string}
     * @memberof CreateDropsBody
     */
    creditLine?: string;
    /**
     * Puck visual builder native JSON. additionalProperties is an empty schema (not `true`) so the generated client types values as `any` and accepts the primitive values Puck emits at the top level of its data object.
     * @type {{ [key: string]: any; }}
     * @memberof CreateDropsBody
     */
    pageBuilderData?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropsBody
     */
    useVisualBuilder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDropsBody
     */
    phase?: CreateDropsBodyPhaseEnum;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof CreateDropsBody
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * Creator storefront link-outs (Streamlabs Merch, Shopify, Fourthwall, Gumroad, Ko-fi, Spring). Optional — auto-create provisioning populates this from parser results; admin-created Drops typically leave this empty. Input shape omits `_id` (Mongo assigns) and `detectedFromUrl` (parser-only).
     * @type {Array<DropStorefrontInput>}
     * @memberof CreateDropsBody
     */
    storefronts?: Array<DropStorefrontInput>;
}


/**
 * @export
 */
export const CreateDropsBodyOwnerTypeEnum = {
    user: 'user',
    organization: 'organization'
} as const;
export type CreateDropsBodyOwnerTypeEnum = typeof CreateDropsBodyOwnerTypeEnum[keyof typeof CreateDropsBodyOwnerTypeEnum];

/**
 * @export
 */
export const CreateDropsBodyPhaseEnum = {
    pre_launch: 'pre_launch',
    live: 'live'
} as const;
export type CreateDropsBodyPhaseEnum = typeof CreateDropsBodyPhaseEnum[keyof typeof CreateDropsBodyPhaseEnum];


/**
 * Check if a given object implements the CreateDropsBody interface.
 */
export function instanceOfCreateDropsBody(value: object): value is CreateDropsBody {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateDropsBodyFromJSON(json: any): CreateDropsBody {
    return CreateDropsBodyFromJSONTyped(json, false);
}

export function CreateDropsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDropsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'dropType': json['dropType'] == null ? undefined : DropTypeFromJSON(json['dropType']),
        'status': json['status'] == null ? undefined : SurfaceStatusFromJSON(json['status']),
        'visibility': json['visibility'] == null ? undefined : SurfaceVisibilityFromJSON(json['visibility']),
        'distributions': json['distributions'] == null ? undefined : ((json['distributions'] as Array<any>).map(DistributionFromJSON)),
        'pointSystemConfig': json['pointSystemConfig'] == null ? undefined : SurfacePointSystemConfigInputFromJSON(json['pointSystemConfig']),
        'verified': json['verified'] == null ? undefined : json['verified'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ownerType': json['ownerType'] == null ? undefined : json['ownerType'],
        'games': json['games'] == null ? undefined : json['games'],
        'themeColors': json['themeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['themeColors']),
        'typography': json['typography'] == null ? undefined : ChallengeTypographyFromJSON(json['typography']),
        'themeConfig': json['themeConfig'] == null ? undefined : SurfaceThemeConfigFromJSON(json['themeConfig']),
        'heroSection': json['heroSection'] == null ? undefined : PageHeroSectionFromJSON(json['heroSection']),
        'navbarConfig': json['navbarConfig'] == null ? undefined : PageNavbarConfigFromJSON(json['navbarConfig']),
        'seo': json['seo'] == null ? undefined : PageSeoFromJSON(json['seo']),
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'questConfigs': json['questConfigs'] == null ? undefined : json['questConfigs'],
        'ledgerOwner': json['ledgerOwner'] == null ? undefined : LedgerOwnerFromJSON(json['ledgerOwner']),
        'ledgerId': json['ledgerId'] == null ? undefined : json['ledgerId'],
        'onboardingExperienceId': json['onboardingExperienceId'] == null ? undefined : json['onboardingExperienceId'],
        'allowedGames': json['allowedGames'] == null ? undefined : ((json['allowedGames'] as Array<any>).map(SurfaceAllowedGameFromJSON)),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(DropSectionFromJSON)),
        'streamingSettings': json['streamingSettings'] == null ? undefined : CreateDropStreamingSettingsFromJSON(json['streamingSettings']),
        'release': json['release'] == null ? undefined : DropReleaseBodyFromJSON(json['release']),
        'campaignWindows': json['campaignWindows'] == null ? undefined : ((json['campaignWindows'] as Array<any>).map(DropCampaignWindowBodyFromJSON)),
        'pov': json['pov'] == null ? undefined : json['pov'],
        'parentDropId': json['parentDropId'] == null ? undefined : json['parentDropId'],
        'rosterFields': json['rosterFields'] == null ? undefined : ((json['rosterFields'] as Array<any>).map(RosterFieldSpecFromJSON)),
        'streamingTeamId': json['streamingTeamId'] == null ? undefined : json['streamingTeamId'],
        'socials': json['socials'] == null ? undefined : ((json['socials'] as Array<any>).map(SurfaceSocialConnectionFromJSON)),
        'contentBlocks': json['contentBlocks'] == null ? undefined : ((json['contentBlocks'] as Array<any>).map(SurfaceContentBlockFromJSON)),
        'creatorProfileImageUrl': json['creatorProfileImageUrl'] == null ? undefined : json['creatorProfileImageUrl'],
        'creatorHeaderImageUrl': json['creatorHeaderImageUrl'] == null ? undefined : json['creatorHeaderImageUrl'],
        'logoImageUrl': json['logoImageUrl'] == null ? undefined : json['logoImageUrl'],
        'iconImageId': json['iconImageId'] == null ? undefined : json['iconImageId'],
        'logoImageId': json['logoImageId'] == null ? undefined : json['logoImageId'],
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'programName': json['programName'] == null ? undefined : json['programName'],
        'memberStatLabel': json['memberStatLabel'] == null ? undefined : json['memberStatLabel'],
        'memberStatDetail': json['memberStatDetail'] == null ? undefined : json['memberStatDetail'],
        'synopsis': json['synopsis'] == null ? undefined : json['synopsis'],
        'purchaseUrl': json['purchaseUrl'] == null ? undefined : json['purchaseUrl'],
        'trailerUrl': json['trailerUrl'] == null ? undefined : json['trailerUrl'],
        'videos': json['videos'] == null ? undefined : ((json['videos'] as Array<any>).map(DropVideoBodyFromJSON)),
        'modes': json['modes'] == null ? undefined : ((json['modes'] as Array<any>).map(DropModeBodyFromJSON)),
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
        'gameRef': json['gameRef'] == null ? undefined : json['gameRef'],
        'twitchGameIds': json['twitchGameIds'] == null ? undefined : json['twitchGameIds'],
        'kickCategoryIds': json['kickCategoryIds'] == null ? undefined : json['kickCategoryIds'],
        'streamTitleAliases': json['streamTitleAliases'] == null ? undefined : json['streamTitleAliases'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'steamNewsAppId': json['steamNewsAppId'] == null ? undefined : json['steamNewsAppId'],
        'creditLine': json['creditLine'] == null ? undefined : json['creditLine'],
        'pageBuilderData': json['pageBuilderData'] == null ? undefined : json['pageBuilderData'],
        'useVisualBuilder': json['useVisualBuilder'] == null ? undefined : json['useVisualBuilder'],
        'phase': json['phase'] == null ? undefined : json['phase'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'storefronts': json['storefronts'] == null ? undefined : ((json['storefronts'] as Array<any>).map(DropStorefrontInputFromJSON)),
    };
}

export function CreateDropsBodyToJSON(json: any): CreateDropsBody {
    return CreateDropsBodyToJSONTyped(json, false);
}

export function CreateDropsBodyToJSONTyped(value?: CreateDropsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'name': value['name'],
        'description': value['description'],
        'dropType': DropTypeToJSON(value['dropType']),
        'status': SurfaceStatusToJSON(value['status']),
        'visibility': SurfaceVisibilityToJSON(value['visibility']),
        'distributions': value['distributions'] == null ? undefined : ((value['distributions'] as Array<any>).map(DistributionToJSON)),
        'pointSystemConfig': SurfacePointSystemConfigInputToJSON(value['pointSystemConfig']),
        'verified': value['verified'],
        'ownerId': value['ownerId'],
        'ownerType': value['ownerType'],
        'games': value['games'],
        'themeColors': ChallengeThemeColorsToJSON(value['themeColors']),
        'typography': ChallengeTypographyToJSON(value['typography']),
        'themeConfig': SurfaceThemeConfigToJSON(value['themeConfig']),
        'heroSection': PageHeroSectionToJSON(value['heroSection']),
        'navbarConfig': PageNavbarConfigToJSON(value['navbarConfig']),
        'seo': PageSeoToJSON(value['seo']),
        'competitionId': value['competitionId'],
        'questConfigs': value['questConfigs'],
        'ledgerOwner': LedgerOwnerToJSON(value['ledgerOwner']),
        'ledgerId': value['ledgerId'],
        'onboardingExperienceId': value['onboardingExperienceId'],
        'allowedGames': value['allowedGames'] == null ? undefined : ((value['allowedGames'] as Array<any>).map(SurfaceAllowedGameToJSON)),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(DropSectionToJSON)),
        'streamingSettings': CreateDropStreamingSettingsToJSON(value['streamingSettings']),
        'release': DropReleaseBodyToJSON(value['release']),
        'campaignWindows': value['campaignWindows'] == null ? undefined : ((value['campaignWindows'] as Array<any>).map(DropCampaignWindowBodyToJSON)),
        'pov': value['pov'],
        'parentDropId': value['parentDropId'],
        'rosterFields': value['rosterFields'] == null ? undefined : ((value['rosterFields'] as Array<any>).map(RosterFieldSpecToJSON)),
        'streamingTeamId': value['streamingTeamId'],
        'socials': value['socials'] == null ? undefined : ((value['socials'] as Array<any>).map(SurfaceSocialConnectionToJSON)),
        'contentBlocks': value['contentBlocks'] == null ? undefined : ((value['contentBlocks'] as Array<any>).map(SurfaceContentBlockToJSON)),
        'creatorProfileImageUrl': value['creatorProfileImageUrl'],
        'creatorHeaderImageUrl': value['creatorHeaderImageUrl'],
        'logoImageUrl': value['logoImageUrl'],
        'iconImageId': value['iconImageId'],
        'logoImageId': value['logoImageId'],
        'tagline': value['tagline'],
        'programName': value['programName'],
        'memberStatLabel': value['memberStatLabel'],
        'memberStatDetail': value['memberStatDetail'],
        'synopsis': value['synopsis'],
        'purchaseUrl': value['purchaseUrl'],
        'trailerUrl': value['trailerUrl'],
        'videos': value['videos'] == null ? undefined : ((value['videos'] as Array<any>).map(DropVideoBodyToJSON)),
        'modes': value['modes'] == null ? undefined : ((value['modes'] as Array<any>).map(DropModeBodyToJSON)),
        'platforms': value['platforms'],
        'gameRef': value['gameRef'],
        'twitchGameIds': value['twitchGameIds'],
        'kickCategoryIds': value['kickCategoryIds'],
        'streamTitleAliases': value['streamTitleAliases'],
        'steamAppId': value['steamAppId'],
        'steamNewsAppId': value['steamNewsAppId'],
        'creditLine': value['creditLine'],
        'pageBuilderData': value['pageBuilderData'],
        'useVisualBuilder': value['useVisualBuilder'],
        'phase': value['phase'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
        'storefronts': value['storefronts'] == null ? undefined : ((value['storefronts'] as Array<any>).map(DropStorefrontInputToJSON)),
    };
}

